import { qualifyUrls } from "routing/Routes";
const WorkspaceRoutes = {
  INTEGRATIONS: {
    Workspace: {
      ACTIVITYAPI: {
        index: "/integrations/googleworkspace"
      }
    }
  }
};
const ApiRoutes = {
  INTEGRATIONS: {
    Workspace: {
      SAVE_INPUT: "/plugins/org.graylog.enterprise.integrations/googleworkspace/inputs?setup_wizard=true"
    }
  }
};
const DocsRoutes = {
  INTEGRATIONS: {
    Workspace: {
      GRAYLOG_Workspace_ACTIVITY_LOG_INPUT: "integrations/inputs/graylog_workspace_ActivityLog_Input.html#graylog-workspace-activitylog-input"
    }
  }
};
export default {
  ...qualifyUrls(WorkspaceRoutes),
  unqualified: WorkspaceRoutes
};
export { DocsRoutes, ApiRoutes };
